import React from "react";
import "antd/dist/antd.css";
import { Tag, Layout, Button, Icon, Table, Divider } from "antd";
import "./articledetails.css";
import QueueAnim from "rc-queue-anim";

const { Content } = Layout;

export default class ArticleDetails extends React.Component {
  render() {
    const {
      title,
      body,
      id,
      authorString,
      affiliation,
      firstPublicationDate,
      doi,
      keyword,
      fullText,
    } = this.props.data;
    const { addFavorite } = this.props;
    const columns = [
      {
        title: "Бесплатный доступ",
        dataIndex: "availability",
      },
      {
        title: "Ссылка",
        dataIndex: "url",
      },
    ];
    const newfullText = fullText.concat().map(function(item, i) {
      return {
        key: i,
        availability: item.availabilityCode === "S" ? "Нет" : "Да",
        url: (
          <a className="url" href={item.url}>
            {item.url}
          </a>
        ),
      };
    });
    return (
      <QueueAnim
        key="demo"
        type={["right", "left"]}
        ease={["easeOutQuart", "easeInOutQuart"]}
      >
        <Content className="content" key={id}>
          <div className="cardText">
            <div style={{ display: "flex" }}>
              <Button
                className="button"
                onClick={() => this.props.select(null)}
                size="default"
              >
                <Icon type="left" />
              </Button>

              <Button
                style={{ marginLeft: "auto" }}
                onClick={() => addFavorite(title, doi, id)}
                size="default"
              >
                <Icon type="star" theme="filled" style={{ color: "#ffdd03" }} />
                В избранное
              </Button>
            </div>
            <h2>{title}</h2>
            <p className="secondInfo">Авторы исследования: {authorString}</p>
            <p className="secondInfo">Принадлежость авторов к: {affiliation}</p>
            <div className="res">
              <h4>Резюме: </h4>
              {body}
            </div>
            <Divider dashed />
            <p className="secondInfo">
              Дата первой публикации {firstPublicationDate}
            </p>
            <p>
              Ключевые слова:
              {!keyword
                ? null
                : keyword.map(function(item, i) {
                    return (
                      <span key={i} style={{ marginLeft: 5 }}>
                        {item}
                      </span>
                    );
                  })}
            </p>
            <h4>Ссылки на полный текст исследования</h4>
            <Table
              className="table"
              columns={columns}
              dataSource={newfullText}
              size="small"
              pagination={{ position: "none" }}
              style={{ marginBottom: 15 }}
            />
            <div className="tagsContainer">
              <Tag className="tag">
                <span>MPID:{id}</span>
              </Tag>
              <Tag className="tag">
                <span>Doi:{doi}</span>
              </Tag>
            </div>
          </div>
        </Content>
      </QueueAnim>
    );
  }
}
